<template>
  <div class="topic">
    <Header />
    <Nav />
    <div class="topic-bg">
      <div class="topic-container">
      <div class="topic-box">
        <div class="topic-title">
          <img src="../assets/common/logo2.png" alt="">
          <el-button>答题卡</el-button>
        </div>
        <h2>考试题</h2>
        <h3>一、单选题（共20题，每题2分，共40分。每题的备选项中，只有1个最符合题意）</h3>
        <div class="q">1.根据《工程建设项目招标范围和规模标准规定》的规定，属于工程建设项目招标范围的工程建设项目，勘察、设计、监理等服务的采购，单项合同估算份在（ ）人民币以上的，必须进行招标。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti1" label="50万元">50万元</el-radio>
          </li>
          <li>
            <el-radio v-model="ti1" label="100万元">100万元</el-radio>
          </li>
          <li>
            <el-radio v-model="ti1" label="150万元">150万元</el-radio>
          </li>
          <li>
            <el-radio v-model="ti1" label="20万元">20万元</el-radio>
          </li>
        </ul>
        <div class="q">2.“评标价”是指（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti2" label="标底价格">标底价格</el-radio>
          </li>
          <li>
            <el-radio v-model="ti2" label="中标的合同价格">中标的合同价格</el-radio>
          </li>
          <li>
            <el-radio v-model="ti2" label="投标书中标明的报价">投标书中标明的报价</el-radio>
          </li>
          <li>
            <el-radio v-model="ti2" label="以价格为单位对各投标书优劣进行比较的量化值">以价格为单位对各投标书优劣进行比较的量化值</el-radio>
          </li>
        </ul>
        <div class="q">3.下列各项中，（ ）不属于工程建设施工招标应具备的前提条件。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti3" label="建设用地征用完毕，施工图纸完成">建设用地征用完毕，施工图纸完成</el-radio>
          </li>
          <li>
            <el-radio v-model="ti3" label="概算已经批准，建设项目己正式列入计划">概算已经批准，建设项目己正式列入计划</el-radio>
          </li>
          <li>
            <el-radio v-model="ti3" label="招标文件已经编制好">招标文件已经编制好 </el-radio>
          </li>
          <li>
            <el-radio v-model="ti3" label="建设资金、建材、设备已经落实">建设资金、建材、设备已经落实</el-radio>
          </li>
        </ul>
        <div class="q">4.一般情况下，（ ）应当由招标人完成。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti4" label="确定中标人">确定中标人 </el-radio>
          </li>
          <li>
            <el-radio v-model="ti4" label="评标情况说明">评标情况说明</el-radio>
          </li>
          <li>
            <el-radio v-model="ti4" label="对各个合格投标书的评价">对各个合格投标书的评价 </el-radio>
          </li>
          <li>
            <el-radio v-model="ti4" label="推荐合格的中标候选人">推荐合格的中标候选人</el-radio>
          </li>
        </ul>
        <div class="q">5.招标人在中标通知书中写明的中标合同价应是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti5" label="初步设计编制的概算价">初步设计编制的概算价</el-radio>
          </li>
          <li>
            <el-radio v-model="ti5" label="施工图设计编制的预算价">施工图设计编制的预算价</el-radio>
          </li>
          <li>
            <el-radio v-model="ti5" label="投标书中标明的报价">投标书中标明的报价</el-radio>
          </li>
          <li>
            <el-radio v-model="ti5" label="评标委员会算出的评标价">评标委员会算出的评标价</el-radio>
          </li>
        </ul>
        <div class="q">6.施工招标文件的内容一般不包括（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti6" label="工程量清单">工程量清单 </el-radio>
          </li>
          <li>
            <el-radio v-model="ti6" label="资格预审条件">资格预审条件</el-radio>
          </li>
          <li>
            <el-radio v-model="ti6" label="合同条件">合同条件</el-radio>
          </li>
          <li>
            <el-radio v-model="ti6" label="投标须知">投标须知</el-radio>
          </li>
        </ul>
        <div class="q">7.甲、乙、丙三家单位组成联合体投标，约定权利义务的承担比例为3:3:4,履行过程中乙破产,招标人要求甲承担原本由乙承担的价值700万元的债务。则（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti7" label="因为有内部关系的约定，中可以不承担这部分债务">因为有内部关系的约定，中可以不承担这部分债务</el-radio>
          </li>
          <li>
            <el-radio v-model="ti7" label="甲不得拒绝招标人的要求，只能自己承担这部分债务">甲不得拒绝招标人的要求，只能自己承担这部分债务</el-radio>
          </li>
          <li>
            <el-radio v-model="ti7" label="甲可以只承担300万无的债务，另外400万元可以建议招标人要求内承担">甲可以只承担300万无的债务，另外400万元可以建议招标人要求内承担</el-radio>
          </li>
          <li>
            <el-radio v-model="ti7" label="甲不得拒绝招标人的要求，但在履行后可向两追偿400万元">甲不得拒绝招标人的要求，但在履行后可向两追偿400万元</el-radio>
          </li>
        </ul>
        <div class="q">8.某省高速公路扩建工程，有甲、丁、丙、丁、戊五家单位参与投标，根据招标投标法的有关规定。下列说法正确的是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti8" label="招标人有可能直接决定中标单位">招标人有可能直接决定中标单位</el-radio>
          </li>
          <li>
            <el-radio v-model="ti8" label="开标时由不同的投标人拆封自己的标书">开标时由不同的投标人拆封自己的标书</el-radio>
          </li>
          <li>
            <el-radio v-model="ti8" label="开标应由招标人主持">开标应由招标人主持</el-radio>
          </li>
          <li>
            <el-radio v-model="ti8" label="开标时发现乙的投标文件没有密封,但若有三家投标单位同意，则该投标文件有效">开标时发现乙的投标文件没有密封,但若有三家投标单位同意，则该投标文件有效</el-radio>
          </li>
        </ul>
        <div class="q">9.关于共同投标协议，下列说法错误的是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti9" label="共同投标协议属于合同关系">共同投标协议属于合同关系</el-radio>
          </li>
          <li>
            <el-radio v-model="ti9" label="共同投标协议必须详细、明确，以免日后发生争议">共同投标协议必须详细、明确，以免日后发生争议</el-radio>
          </li>
          <li>
            <el-radio v-model="ti9" label="共同协议不应同投标文件一并提交招标人">共同协议不应同投标文件一并提交招标人</el-radio>
          </li>
          <li>
            <el-radio v-model="ti9" label="联合体内部各方通过共同投标协议，明确约定各方在中标后要承担的工作和责任">联合体内部各方通过共同投标协议，明确约定各方在中标后要承担的工作和责任</el-radio>
          </li>
        </ul>
        <div class="q">10.下列关于连带责任的叙述中，说法错误的是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti10" label="债权人可以向任何一个或者多个债务人请求履行债务">债权人可以向任何一个或者多个债务人请求履行债务</el-radio>
          </li>
          <li>
            <el-radio v-model="ti10" label="负有连带责任债务人可以以债务人之间对债务分担比例有约定来拒绝履行债务">负有连带责任债务人可以以债务人之间对债务分担比例有约定来拒绝履行债务</el-radio>
          </li>
          <li>
            <el-radio v-model="ti10" label="负有连带责任债务人中一人或者多人履行了全部债务后，其他连带债务人对债权人的履行义务即行解除">负有连带责任债务人中一人或者多人履行了全部债务后，其他连带债务人对债权人的履行义务即行解除</el-radio>
          </li>
          <li>
            <el-radio v-model="ti10" label="对负有连带责任债务人，根据其内部约定，债务人清偿债务超过其应承当份额的，有权向其他连带债务人造偿">对负有连带责任债务人，根据其内部约定，债务人清偿债务超过其应承当份额的，有权向其他连带债务人造偿</el-radio>
          </li>
        </ul>
        <div class="q">11.下列选项中，属于教标人与招标人之间串通投标行为的是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti11" label="甲、乙、丙、丁四家单位参加竞标，在竞标过程中均高价投标">甲、乙、丙、丁四家单位参加竞标，在竞标过程中均高价投标</el-radio>
          </li>
          <li>
            <el-radio v-model="ti11" label="甲、乙、丙、丁四家单位参加竞标，在竞标前四家单位先进行内部竞价，选定丙为中标人后，再参加投标">甲、乙、丙、丁四家单位参加竞标，在竞标前四家单位先进行内部竞价，选定丙为中标人后，再参加投标</el-radio>
          </li>
          <li>
            <el-radio v-model="ti11" label="甲、乙、丙、丁四家单位参加竞标，招标人向甲单位泄漏了标底">甲、乙、丙、丁四家单位参加竞标，招标人向甲单位泄漏了标底</el-radio>
          </li>
          <li>
            <el-radio v-model="ti11" label="甲、乙、丙、丁四家单位参加竞标，乙单位为中标向招标人某国税局的局党委书记行贿">甲、乙、丙、丁四家单位参加竞标，乙单位为中标向招标人某国税局的局党委书记行贿</el-radio>
          </li>
        </ul>
        <div class="q">12.对于中标通知书的法律效力下列说法正确的是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti12" label="中标通知书就是正式的合同">中标通知书就是正式的合同</el-radio>
          </li>
          <li>
            <el-radio v-model="ti12" label="中标通知书属于要约邀请">中标通知书属于要约邀请</el-radio>
          </li>
          <li>
            <el-radio v-model="ti12" label="中标通知书属于要约">中标通知书属于要约</el-radio>
          </li>
          <li>
            <el-radio v-model="ti12" label="中标通知书属于承诺">中标通知书属于承诺</el-radio>
          </li>
        </ul>
        <div class="q">13.在下列费用中，属于建筑安装工程间接费的是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti13" label="施工单位搭设的临时设施费">施工单位搭设的临时设施费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti13" label="危险作业意外伤害保险费">危险作业意外伤害保险费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti13" label="劳动保障费">劳动保障费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti13" label="已完工程和设备保护费">已完工程和设备保护费</el-radio>
          </li>
        </ul>
        <div class="q">14.按我国现行《建筑安装工程费用项目组成》（建标[2022]206号文)的规定，建筑安装工程费用的组成为（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti14" label="直接费、间接费、计划利润、税金">直接费、间接费、计划利润、税金</el-radio>
          </li>
          <li>
            <el-radio v-model="ti14" label="直接工程费、间接费、利润、税金">直接工程费、间接费、利润、税金</el-radio>
          </li>
          <li>
            <el-radio v-model="ti14" label="直接费、规费、间接费、税金">直接费、规费、间接费、税金</el-radio>
          </li>
          <li>
            <el-radio v-model="ti14" label="直接费、间接费、利润、税金">直接费、间接费、利润、税金</el-radio>
          </li>
        </ul>
        <div class="q">15.下列费用中，属于建筑安装工程直接费的是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti15" label="施工单位搭设的临时设施费">施工单位搭设的临时设施费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti15" label="现场管理">现场管理</el-radio>
          </li>
          <li>
            <el-radio v-model="ti15" label="施工企业管理费">施工企业管理费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti15" label="工程点交费">工程点交费</el-radio>
          </li>
        </ul>
        <div class="q">16.下列不属于材料费用的是（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti16" label="材料原价">材料原价</el-radio>
          </li>
          <li>
            <el-radio v-model="ti16" label="材料运杂费">材料运杂费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti16" label="材料采购保管费">材料采购保管费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti16" label="材料二次搬运费">材料二次搬运费</el-radio>
          </li>
        </ul>
        <div class="q">17.按建标[2022]206号文的规定，建筑安装工程费用中的规费包括了（ ）费用。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti17" label="工程排污、保障、危险作业意外伤害保险">工程排污、保障、危险作业意外伤害保险</el-radio>
          </li>
          <li>
            <el-radio v-model="ti17" label="住房公积金、工程排污、环境保护">住房公积金、工程排污、环境保护</el-radio>
          </li>
          <li>
            <el-radio v-model="ti17" label="保障、安全施工、环境保护">保障、安全施工、环境保护</el-radio>
          </li>
          <li>
            <el-radio v-model="ti17" label="住房公积金、危险作业意外伤害保险、安全施工">住房公积金、危险作业意外伤害保险、安全施工</el-radio>
          </li>
        </ul>
        <div class="q">18.建筑安装工程施工中的工程排污费属于（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti18" label="其他直接费">其他直接费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti18" label="现场管理费">现场管理费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti18" label="规费">规费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti18" label="直接费">直接费</el-radio>
          </li>
        </ul>
        <div class="q">19.建筑安装企业支付的病假在6个月以上的生产工人的工资应计入（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti19" label="生产工人辅助工资">生产工人辅助工资</el-radio>
          </li>
          <li>
            <el-radio v-model="ti19" label="劳动保险费">劳动保险费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti19" label="待业保险费">待业保险费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti19" label="现场管理费">现场管理费</el-radio>
          </li>
        </ul>
        <div class="q">20.建筑安装企业支付的离退休职工的易地安家补助费应计入（ ）。</div>
        <ul class="a">
          <li>
            <el-radio v-model="ti20" label="生产工人辅助工资">生产工人辅助工资</el-radio>
          </li>
          <li>
            <el-radio v-model="ti20" label="劳动保险费">劳动保险费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti20" label="待业保险费">待业保险费</el-radio>
          </li>
          <li>
            <el-radio v-model="ti20" label="现场管理费">现场管理费</el-radio>
          </li>
        </ul>
        <h3>二、多项选择题(共10题，每题2分，共20分。每题的备选项中，有2个或2个以上符合题意，至少有1个错项。）</h3>
        <div class="q">1.招标人可以没收投标保证金的情况有（ ）。</div>
        <el-checkbox-group v-model="check1">
          <ul class="a">
            <li>
              <el-checkbox label="投标人在投标截止日前撤回投标书">投标人在投标截止日前撤回投标书</el-checkbox>
            </li>
            <li>
              <el-checkbox label="投标人在找标有效期内撤销投标书">投标人在找标有效期内撤销投标书</el-checkbox>
            </li>
            <li>
              <el-checkbox label="投标人在中标后拒签合同">投标人在中标后拒签合同</el-checkbox>
            </li>
            <li>
              <el-checkbox label="投标人在中标后拒交履约保函">投标人在中标后拒交履约保函</el-checkbox>
            </li>
            <li>
              <el-checkbox label="投标人有可能在合同履行中违约">投标人有可能在合同履行中违约</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">2.《招投标法》规定，投标文件（ ）的投标人应确定为中标人。</div>
        <el-checkbox-group v-model="check2">
          <ul class="a">
            <li>
              <el-checkbox label="满足招标文件中规定的各项综合评价标准的最低要求">满足招标文件中规定的各项综合评价标准的最低要求</el-checkbox>
            </li>
            <li>
              <el-checkbox label="最大限度地满足招标文件中规定的各项综合评价标准">最大限度地满足招标文件中规定的各项综合评价标准</el-checkbox>
            </li>
            <li>
              <el-checkbox label="满足招标文件各项要求，并且报价最低">满足招标文件各项要求，并且报价最低</el-checkbox>
            </li>
            <li>
              <el-checkbox label="满足招标文件各项要求，并且经评审的价格最低">满足招标文件各项要求，并且经评审的价格最低</el-checkbox>
            </li>
            <li>
              <el-checkbox label="满足招标文件各项要求，并且经评审价格最高">满足招标文件各项要求，并且经评审价格最高</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">3.政府行政主管部门对招标投标活动进行的监督包括（ ）等方面。</div>
        <el-checkbox-group v-model="check3">
          <ul class="a">
            <li>
              <el-checkbox label="检查必须采用招标方式选择承包单位的建设项目">检查必须采用招标方式选择承包单位的建设项目</el-checkbox>
            </li>
            <li>
              <el-checkbox label="对招标有关文件的核查备案">对招标有关文件的核查备案 </el-checkbox>
            </li>
            <li>
              <el-checkbox label="投标人履行合同的能力评定">投标人履行合同的能力评定</el-checkbox>
            </li>
            <li>
              <el-checkbox label="评标委员会成员资格认定">评标委员会成员资格认定 </el-checkbox>
            </li>
            <li>
              <el-checkbox label="查处招投标活动的违法行为">查处招投标活动的违法行为</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">4. 招标方式中，邀请招标与公开招标比较，其缺点主要有（ ）等。</div>
        <el-checkbox-group v-model="check4">
          <ul class="a">
            <li>
              <el-checkbox label="选择面窄，排斥了某些有竞争实力的潜在投标人">选择面窄，排斥了某些有竞争实力的潜在投标人</el-checkbox>
            </li>
            <li>
              <el-checkbox label="竞争的激烈程度相对较差">竞争的激烈程度相对较差</el-checkbox>
            </li>
            <li>
              <el-checkbox label="招标时间长">招标时间长</el-checkbox>
            </li>
            <li>
              <el-checkbox label="招标费用高">招标费用高</el-checkbox>
            </li>
            <li>
              <el-checkbox label="评标工作量较大">评标工作量较大</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">5.工程建设项目招标范围包括（ ）。</div>
        <el-checkbox-group v-model="check5">
          <ul class="a">
            <li>
              <el-checkbox label="大型基础设施、公用事业等关系，公共利益、公众安全的项目">大型基础设施、公用事业等关系，公共利益、公众安全的项目</el-checkbox>
            </li>
            <li>
              <el-checkbox label="一切工程项目">一切工程项目</el-checkbox>
            </li>
            <li>
              <el-checkbox label="全部或者部分使用国有资命投资或者国家融资的项目">全部或者部分使用国有资命投资或者国家融资的项目</el-checkbox>
            </li>
            <li>
              <el-checkbox label="一切大中型工程项目">一切大中型工程项目</el-checkbox>
            </li>
            <li>
              <el-checkbox label="使用国际组织或者外国政府贷款、援助资金的项目">使用国际组织或者外国政府贷款、援助资金的项目</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">6.计算施工机械使用费需要确定机械台班单价，机械台班单价的确定需要（ ）等几项内容。</div>
        <el-checkbox-group v-model="check6">
          <ul class="a">
            <li>
              <el-checkbox label="台班折旧费、大修费、台班经常修理费">台班折旧费、大修费、台班经常修理费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="全年有效工作日">全年有效工作日</el-checkbox>
            </li>
            <li>
              <el-checkbox label="台班安拆费及场外运费">台班安拆费及场外运费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="台班人工费、台班燃料动力费">台班人工费、台班燃料动力费 </el-checkbox>
            </li>
            <li>
              <el-checkbox label="台班养路费及车船使用税">台班养路费及车船使用税</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">7.下列费用中，属于建筑安装工程间接费的有（ ）。</div>
        <el-checkbox-group v-model="check7">
          <ul class="a">
            <li>
              <el-checkbox label="企业管理费">企业管理费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="工程监理费">工程监理费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="建设单位管理费">建设单位管理费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="住房公积金">住房公积金</el-checkbox>
            </li>
            <li>
              <el-checkbox label="勘查设计费">勘查设计费</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">8.下列费用中，不属于建筑安装工程直接工程费的有（ ）。</div>
        <el-checkbox-group v-model="check8">
          <ul class="a">
            <li>
              <el-checkbox label="施工机械大修费">施工机械大修费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="材料二次搬还费">材料二次搬还费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="生产工人退休工资">生产工人退休工资</el-checkbox>
            </li>
            <li>
              <el-checkbox label="生产职工教育经费">生产职工教育经费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="生产工具、用具使用费">生产工具、用具使用费</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">9.下列费用中能列入建筑安装工程直接工程费中的人工费的有（ ）。</div>
        <el-checkbox-group v-model="check9">
          <ul class="a">
            <li>
              <el-checkbox label="生产工人劳动保护费">生产工人劳动保护费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="生产工人探亲假期的工资">生产工人探亲假期的工资</el-checkbox>
            </li>
            <li>
              <el-checkbox label="生产工人退休工资">生产工人退休工资</el-checkbox>
            </li>
            <li>
              <el-checkbox label="生产工人福利费">生产工人福利费</el-checkbox>
            </li>
            <li>
              <el-checkbox label="生产职工教育经费">生产职工教育经费</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div class="q">10.直接工程费中人工费包括生产工人（ ）的工资。</div>
        <el-checkbox-group v-model="check10">
          <ul class="a">
            <li>
              <el-checkbox label="修建临时设施">修建临时设施</el-checkbox>
            </li>
            <li>
              <el-checkbox label="因气候影响停工期间">因气候影响停工期间</el-checkbox>
            </li>
            <li>
              <el-checkbox label="病假6个月以内">病假6个月以内</el-checkbox>
            </li>
            <li>
              <el-checkbox label="调动工作期间">调动工作期间 </el-checkbox>
            </li>
            <li>
              <el-checkbox label="休假期间">休假期间</el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <h3>三、简答题（共5题，每题4分，共20分)</h3>
        <div class="q">1.风险型CM模式有哪些优点及缺点?</div>
        <div class="a">
          <el-input type="textarea" v-model="textarea1"></el-input>
        </div>
        <div class="q">2.什么是公开招标？公开招标有哪些特点?</div>
        <div class="a">
          <el-input type="textarea" v-model="textarea2"></el-input>
        </div>
        <div class="q">3.招标的有关文件应包括哪些？</div>
        <div class="a">
          <el-input type="textarea" v-model="textarea3"></el-input>
        </div>
        <div class="q">4.什么情况属于重大偏差?</div>
        <div class="a">
          <el-input type="textarea" v-model="textarea4"></el-input>
        </div>
        <div class="q">5.什么情况施工企业应当放弃投标？</div>
        <div class="a">
          <el-input type="textarea" v-model="textarea5"></el-input>
        </div>
        <div class="topic-btn" @click="finish">确认提交</div>
      </div>
    </div>
    </div>
    
    <div class="topic-finish" v-if="boxflag">
      <div class="topic-finish-container">
        <div class="topic-finish-close">
          <img src="../assets/examlist/close.svg" alt="" @click="close">
        </div>
        <div class="topic-finish-content">
          <img src="../assets/topic/finish.gif" alt="">
          <p>答题完成</p>
        </div>
        <div class="topic-finish-btn" @click="gohome">返回首页</div>
      </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from '../components/Fixed.vue';
export default {
  name: "Topic",
  components: {
    Header,
    Nav,
    Footer,
    Fixed,
  },
  data() {
    return {
      ti1: "",
      ti2: "",
      ti3: "",
      ti4: "",
      ti5: "",
      ti6: "",
      ti7: "",
      ti8: "",
      ti9: "",
      ti10: "",
      ti11: "",
      ti12: "",
      ti13: "",
      ti14: "",
      ti15: "",
      ti16: "",
      ti17: "",
      ti18: "",
      ti19: "",
      ti20: "",
      check1: [],
      check2: [],
      check3: [],
      check4: [],
      check5: [],
      check6: [],
      check7: [],
      check8: [],
      check9: [],
      check10: [],
      textarea1: "",
      textarea2: "",
      textarea3: "",
      textarea4: "",
      textarea5: "",
      boxflag: false
    };
  },
  methods: {
    finish() {
      this.boxflag = true
    },
    close() {
      this.boxflag = false
    },
    gohome() {
      this.$router.push('/')
    }
  }
};
</script>

<style lang="less" scoped>
.topic {
  &-bg {
    background: #F4F7F9;
    padding-top: 27px;
    padding-bottom: 63px;
  }
  &-container {
    width: 1300px;
    margin: 0 auto 24px;
    background: #fff;
    padding-top: 63px;
    padding-bottom: 63px;
  }
  &-box {
    width: 1094px;
    background: #ffffff;
    box-shadow: 0px 4px 12px 5px rgba(0, 0, 0, 0.08);
    border: 1px solid #eeeeee;
    margin: 0 auto;
    padding: 0 52px;
    box-sizing: border-box;
    padding-bottom: 100px;
  }
  &-title {
    width: 1000px;
    border-bottom: 1px solid #e2e4ea;
    margin: 0 auto;
    padding-top: 35px;
    padding-bottom: 22px;
    display: flex;
    justify-content: space-between;
    img {
      width: 175px;
      height: 24px;
    }
  }
  h2 {
    font-size: 36px;
    font-family: FZCSJW--GB1-0, FZCSJW--GB1;
    font-weight: normal;
    color: #111a34;
    line-height: 40px;
    margin-top: 39px;
    margin-bottom: 62px;
    text-align: center;
  }
  h3 {
    margin-bottom: 20px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #202429;
    line-height: 28px;
  }
  .q {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #202429;
    line-height: 28px;
    margin-top: 10px;
  }
  .a {
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #666f83;
    line-height: 28px;
  }
  &-btn {
    width: 184px;
    height: 32px;
    background: linear-gradient(90deg, #fd441f 0%, #e1251b 100%);
    border-radius: 2px;
    border: 1px solid #e1251b;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    margin: 40px auto;
    cursor: pointer;
  }
  &-finish {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.3);
    z-index: 11;
    &-container {
      width: 401px;
      height: 251px;
      background: url(../assets/topic/finish.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &-close {
      text-align: right;
      padding-top: 5px;
      padding-right: 8px;
      img {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
    &-content {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 45px;
      img {
        width: 59px;
        height: 58px;
      }
      p {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0,0,0,0.9);
        line-height: 24px;
        margin-left: 12px;
      }
    }
    &-btn {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0052D9;
      line-height: 56px;
      border-top: #e7e7e7 1px solid;
      margin-top: 64px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>